import { createIcon } from '../createIcon';

export const FontIconConfig = {
  name: 'FontIcon',
  height: 512,
  width: 448,
  svgPath: 'M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const FontIcon = createIcon(FontIconConfig);

export default FontIcon;